import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";

export class CompanyDocHelpers {
  public static getFolderPath(companyId: string | undefined): string {
    try {
      if (companyId === undefined) throw new Error("companyId is undefined");
      return `companies/${companyId}/docs/`;
    } catch (error: unknown) {
      appFaultModel.catchAppError("CompanyDocHelpers.getFolderPath", { companyId }, error);
      throw error;
    }
  }
}
